module.exports = __webpack_public_path__ + "static/media/dartIcon.60fbd31a.webp";